import { useCallback } from "react";

import useAsync from "astrid-hooks/src/useAsync";

import storageURL from "../helpers/storageURL";

export default function useStorageURL(source) {
	return useAsync(useCallback(() => storageURL(source), [source]));
}
